import { api, auth } from '@/f1/service';
import _ from 'lodash'
import priceModal from '../Price.i18n'
import historyModal from '../History.i18n'
// import historyModal from '../History'
// import EventBus from '../EventBus';
// import Vue from 'vue';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 12,
  currentPage: 1,
  totalRows: 0,
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', 'sv' : '', 'skt' : '', 'opt' : { },
  body : {
    and : [ { name : 'is_del', value : false, op : '=' } ],
    sort : [ { name : 'group_id' }, { name : 'id', op : 'desc' } ]
  }
})

export default {
  components: { priceModal, historyModal },
  data : () => ({
    confirm_payment_history : false,
    payment_history : '',

    history : [],

    model : { credit : 0 },
    invoices : undefined,
    last_invoice: undefined,
    current : undefined,
    modal_price : false,
    auth,
    so : default_opt(),
    current_service : undefined,
    hide_canceled : true,
  }),
  computed: {
    pay() { return _i18n_data.i18n_fields[this.i18n]; },

  },
  methods: {
    refresh() {
      this.$refs._list && this.$refs._list.refresh()
    },
    modal_history(history) {
      if(!history) { return this.$toastr.e(`${_i18n_data._i18n_error.modal_history[this.i18n]}`) }
      console.log(history.length)
      this.history = []
      history.forEach(r => {
        try {
          this.history.push(JSON.parse(r))
        } catch (e) {
          console.error(e)
          this.history.push(r)
        }
      });
      // this.$history_modal.show()
      console.log("payment history load", history.length)
    },
    getRowCount () { return this.so.totalRows || 0 },
    async Summary(){
      let rs = await api.board.Billing({ target: 'group', cmd: 'summary', user : { group_id : auth.profile.group_id }, body : { hide_cancel : this.hide_canceled } })
      if(rs.error) { return this.$toast.e(`${i18n_data._i18n_error.get[this.i18n]}`, `${i18n_data._i18n_error.failed[this.i18n]}`) }

      this.model = Object.assign({}, this.model, rs.body)
      this.invoices = this.model.invoices;
      this.last_invoice = _.max(_.map(this.invoices || [], r => { return r.is_paid == true ? r : '' }), r => r.id)
      this.so.totalRows = this.invoices.length;
      this.current = _.max(this.model.current, r => r.id);

      if(this.model.services) { this.current_service = _.filter(this.model.services, r => r.service_name == this.current.servicename) }
      this.current_service = this.current_service ? _.head(this.current_service) : {}
      // EventBus.$emit('services1', this.model.services);
      // this.current_service.customer_price = 100 // for debug

      return this.invoices
    },
    async load() { return this.Summary() },
  },
  watch: { '$route' (to, from) { console.debug(from) } },
  created() { console.log('[Console] Billing System', 'created'); },
  destroyed() { console.log('[Console] Billing System', 'destroyed'); },
  mounted() { console.log('[Console] Billing System', 'mounted'); this.load();},
}
